<template>
  <div class="all">
    <!-- tittle -->
    <div class="title">
      <div class="title_left"></div>

      <div class="title_middle" @click="goTo()">智能巡检车运营调度</div>
      <div class="title_right"></div>
    </div>

    <!-- 地图 -->

    <!-- <div class="_map"> -->
    <div id="container"></div>
    <!-- <el-amap :amap-manager="amapManager" :events="events" :center="center" :zoom="zoom" :plugin="plugin"
        class="amap-demo" /> -->
    <!-- </div> -->
    <!-- ---------------------------地图结束 -->

    <!--车辆参数 左边 -->
    <div class="left_msg msg1">
      <!-- 第一行 目标速度 -->
      <div class="common">
        <div class="com_icon">
          <img class="ico" src="../../assets/img/sudu.png" />
        </div>
        <div class="com_txt">目标速度</div>
        <div class="com_msg">10km/h</div>
      </div>
      <!-- 第二行 -->
      <div class="common jiaodu">
        <div class="com_icon">
          <img class="ico" src="../../assets/img/jiaodu.png" />
        </div>
        <div class="com_txt">目标角度</div>
        <div class="com_msg">50°</div>
      </div>
    </div>

    <!-- 当前角度 当前速度 -->
    <div class="left_msg msg2">
      <!-- 第一行 目标速度 -->
      <div class="common now">
        <div class="com_icon">
          <img class="ico" src="../../assets/img/sudu.png" />
        </div>
        <div class="com_txt">当前速度</div>
        <div class="com_msg">10km/h</div>
      </div>
      <!-- 第二行 -->
      <div class="common now_jiaodu">
        <div class="com_icon">
          <img class="ico" src="../../assets/img/jiaodu.png" />
        </div>
        <div class="com_txt">当前角度</div>
        <div class="com_msg">50°</div>
      </div>
    </div>
    <!-- 电机转速 电机温度 驾驶模式  -->
    <div class="left_msg msg3">
      <!-- 第一行 目标速度 -->
      <div class="common dianji">
        <div class="com_icon">
          <img class="ico" src="../../assets/img/sudu.png" />
        </div>
        <div class="com_txt">电机转速</div>
        <div class="com_msg">10km/h</div>
      </div>
      <!-- 第二行 -->
      <div class="common wendu">
        <div class="com_icon">
          <img class="ico" src="../../assets/img/jiaodu.png" />
        </div>
        <div class="com_txt">电机温度</div>
        <div class="com_msg">50℃</div>
      </div>
      <!-- 第三行 -->
      <div class="common driving">
        <div class="com_icon">
          <img class="ico" src="../../assets/img/jiaodu.png" />
        </div>
        <div class="com_txt">驾驶模式</div>
        <div class="com_msg">自动驾驶</div>
      </div>
      <!-- 第四行 -->
      <div class="common">
        <div class="com_icon">
          <img class="ico" src="../../assets/img/jiaodu.png" />
        </div>
        <div class="com_txt">信号强度</div>
        <div class="com_msg">自动驾驶</div>
      </div>
    </div>
    <!-- 累计 -->
    <div class="left_msg msg4">
      <!-- 第一行 剩余电量 -->
      <div class="common electricity">
        <div class="last_ele">剩余电量</div>
        <div class="last_line">
          <battery
            style="width: 50%; height: 80%"
            :proIsCharge="IsCharge"
            :proQuantity="batteryEnegy"
          ></battery>
          <span style="margin-top: 3%">{{ batteryEnegy }}%</span>
        </div>
      </div>
      <!-- 第二行 -->
    </div>
    <!-- 累计里程 急停状态 车辆状态 充电状态 -->
    <div class="left_msg msg5">
      <div class="common dianji">
        <div class="com_icon">
          <img class="rico" src="../../assets/img/sudu.png" />
        </div>
        <div class="com_txt">累计里程</div>
        <div class="com_msg">500km</div>
      </div>
      <!-- 急停状态 -->
      <div class="common other_msg1">
        <div class="com_icon">
          <img class="ico" src="../../assets/img/sudu.png" />
        </div>
        <div class="com_txt">急停状态</div>
        <div class="com_msg">正常</div>
      </div>
      <!-- 车辆状态 -->
      <div class="common other_msg1">
        <div class="com_icon">
          <img class="ico" src="../../assets/img/sudu.png" />
        </div>
        <div class="com_txt">车辆状态</div>
        <div class="com_msg">正常</div>
      </div>
      <!-- 充电状态 -->
      <div class="common other_msg1">
        <div class="com_icon">
          <img class="ico" src="../../assets/img/sudu.png" />
        </div>
        <div class="com_txt">充电状态</div>
        <div class="com_msg">正在充电</div>
      </div>
    </div>

    <!-- 当前任务 当前状态 -->
    <div class="left_msg msg6">
      <!-- 第一行 -->
      <div class="common other_msg">
        <div class="com_txt">当前任务</div>
        <div class="com_msg">无无无</div>
      </div>
      <div class="common other_msg">
        <div class="com_txt">任务状态</div>
        <div class="com_msg">执行中</div>
      </div>
    </div>
    <!-- 菜单 -->
    <div class="menu" v-drag>
      <!-- 左1 -->
      <div v-show="show_menu">
        <div @click="dialogTableCar = true">
          <img class="menu_img1" src="../../assets/img/car/left_menu1.png" />
          <div class="car_list">车辆列表</div>
        </div>
        <div @click="dialogFormTask = true">
          <img class="menu_img2" src="../../assets/img/car/left_menu2.png" />
          <div class="new_task">新建任务</div>
        </div>
        <div @click="dialogTask = true">
          <img class="menu_img3" src="../../assets/img/car/right_menu1.png" />
          <div class="task_stop">任务暂停</div>
        </div>
        <div @click="dialogEnd = true">
          <img class="menu_img4" src="../../assets/img/car/r_menu2.png" />
          <div class="task_end">任务终止</div>
        </div>
      </div>

      <div class="inmenu" id="bd" @click="hmenu">菜单</div>
    </div>

    <!-- 右侧 -->
    <div class="right_msg rmsg_0">
      <!-- 天气 -->
      <div class="weather">
        <iframe
          scrolling="no"
          src="https://tianqiapi.com/api.php?style=ya&skin=cucumber&color=ffffff"
          frameborder="0"
          width="220"
          height="200"
          allowtransparency="true"
        ></iframe>
      </div>
    </div>

    <!-- 视频 -->
    <div class="common_video video1">
      <div>
        <div class="mask" v-if="showModal" @click="showModal = false"></div>
        <div class="pop" v-if="showModal">
          <el-button
            icon="el-icon-close"
            @click="showModal = false"
            class="glass"
            circle
          ></el-button>
        </div>
        <el-button
          icon="el-icon-full-screen"
          @click="showModal = true"
          class="glass"
          circle
        ></el-button>
      </div>
      <div class="in_video1">暂无视频</div>
    </div>
    <div class="common_video video2">
      <div>
        <div class="mask" v-if="showModal" @click="showModal = false"></div>
        <div class="pop" v-if="showModal">
          <el-button
            icon="el-icon-close"
            @click="showModal = false"
            class="glass"
            circle
          ></el-button>
        </div>
        <el-button
          icon="el-icon-full-screen"
          @click="showModal = true"
          class="glass"
          circle
        ></el-button>
      </div>
      <div class="in_video2">暂无视频</div>
    </div>
    <div class="common_video video3">
      <div>
        <div class="mask" v-if="showModal" @click="showModal = false"></div>
        <div class="pop" v-if="showModal">
          <el-button
            icon="el-icon-close"
            @click="showModal = false"
            class="glass"
            circle
          ></el-button>
        </div>
        <el-button
          icon="el-icon-full-screen"
          @click="showModal = true"
          class="glass"
          circle
        ></el-button>
      </div>
      <div class="in_video2">暂无视频</div>
    </div>

    <!-- 任务暂停弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogTask"
      width="30%"
      :before-close="handleClose"
    >
      <span>是否暂停该任务</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTask = false">取 消</el-button>
        <el-button type="primary" @click="dialogTask = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 任务终止弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogEnd"
      width="30%"
      :before-close="handleClose"
    >
      <span>是否终止该任务</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogEnd = false">取 消</el-button>
        <el-button type="primary" @click="dialogEnd = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 车辆列表弹框 -->
    <div class="dialog-wrapper">
      <el-dialog title="车辆列表" :visible.sync="dialogTableCar">
        <!-- 搜索 -->
        <el-form :inline="true" :model="formInlines" class="user-search">
          <el-form-item label="搜索：">
            <el-input
              size="small"
              v-model="formInlines.carId"
              placeholder="请输入车辆编号"
            ></el-input>
          </el-form-item>
          <el-form-item label>
            <el-input
              size="small"
              v-model="formInlines.carNumber"
              placeholder="输入车辆牌号"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-search"
            
              >搜索</el-button
            >
            
          </el-form-item>
        </el-form>

        <el-table class="dialogTableCar" :data="gridData">
          <el-table-column
            property="name"
            label="车辆编号"
            width="200"
          ></el-table-column>
          <el-table-column property="address" label="车牌号"></el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="100">
        </el-pagination>
      </el-dialog>
    </div>
    <!--新建任务弹框  -->
    <el-dialog
      title="新建任务"
      :visible.sync="dialogFormTask"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        style="padding-right: 5%"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="任务名称" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="选择车辆" prop="map">
          <div class="chooseMap">
            <div @click="innerVisibleCar = true" class="in_chooseMap">
              <div style="margin-left: 3%">{{ car }}</div>
              <div style="float: right">></div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="地图选择" prop="map">
          <div class="chooseMap">
            <div @click="innerVisibleMap = true" class="in_chooseMap">
              <div style="margin-left: 3%">{{ map }}</div>
              <div style="float: right">></div>
            </div>
          </div>
        </el-form-item>

        <el-form-item v-if="routeShow" label="线路选择" prop="route">
          <div class="chooseMap">
            <div @click="innerVisibleRoute = true" class="in_chooseMap">
              <div style="margin-left: 3%">{{ Route }}</div>
              <div style="float: right">></div>
            </div>
          </div>
        </el-form-item>

        <!-- <div style="width: 80%;margin-left: 5%; display: flex;">
          <el-form-item label="是否开启洒水" prop="delivery">
            <el-switch v-model="ruleForm.delivery"></el-switch>
          </el-form-item>
          <el-form-item style="margin-left: 10%;" label="是否开启清扫" prop="clean">
            <el-switch v-model="ruleForm.clean"></el-switch>
          </el-form-item>
        </div> -->
        <!-- <el-form-item label="水位阈值" prop="waterLevel">
          <el-input v-model="ruleForm.waterLevel" placeholder="请输入水位阈值"></el-input>
        </el-form-item> -->
        <el-form-item label="电量阈值" prop="ele">
          <el-input
            v-model="ruleForm.ele"
            placeholder="请输入电量阈值"
          ></el-input>
        </el-form-item>
        <el-form-item label="运行时间" prop="run_time">
          <el-date-picker
            style="width: 100%"
            v-model="runTime"
            type="datetimerange"
            align="right"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['12:00:00', '08:00:00']"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="运行次数" prop="run_num">
          <el-input
            v-model="ruleForm.run_num"
            placeholder="请输入运行次数"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input type="textarea" v-model="ruleForm.note"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogFormTask = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>

      <!-- -------------------- -->

      <!-- 内层选择车辆 -->
      <el-dialog
        width="30%"
        title="选择车辆"
        :visible.sync="innerVisibleCar"
        append-to-body
      >
        <!-- 搜索 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="车辆编号">
            <el-input
              v-model="formInline.name"
              placeholder="车辆编号"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="onSubmit"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              @click="chooseCar"
              >添加</el-button
            >
          </el-form-item>
        </el-form>
        <el-table :data="gridData">
          <el-table-column
            align="center"
            width="50"
            type="selection"
            reserve-selection
          ></el-table-column>
          <el-table-column
            align="center"
            property="name"
            label="车辆编号"
            width="200"
          ></el-table-column>
          <el-table-column
            align="center"
            property="address"
            label="车牌号"
          ></el-table-column>
        </el-table>
        <Pagination></Pagination>
      </el-dialog>
      <!-- --------选择车辆结束 -->
      <!-- </span> -->
      <!-- 内层选择地图 -->
      <el-dialog
        width="30%"
        title="选择地图"
        :visible.sync="innerVisibleMap"
        append-to-body
      >
        <!-- 搜索 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="地图名称">
            <el-input
              v-model="formInline.name"
              placeholder="地图名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="onSubmit"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              @click="chooseMap"
              >添加</el-button
            >
          </el-form-item>
        </el-form>
        <el-table :data="gridData">
          <el-table-column
            align="center"
            width="50"
            type="selection"
            reserve-selection
          ></el-table-column>
          <el-table-column
            align="center"
            property="name"
            label="地图名称"
            width="200"
          ></el-table-column>
          <el-table-column
            align="center"
            property="address"
            label="地图编号"
          ></el-table-column>
        </el-table>
        <Pagination
          v-bind:child-msg="pageparm"
          @callFather="callFather"
        ></Pagination>
        <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
      </el-dialog>
      <!-- -------结束 -->
      <!-- 内层选择线路 -->
      <el-dialog
        width="30%"
        title="选择线路"
        :visible.sync="innerVisibleRoute"
        append-to-body
      >
        <!-- 搜索 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="线路名称">
            <el-input
              v-model="formInline.name"
              placeholder="线路名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="onSubmit"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              @click="chooseRoute"
              >添加</el-button
            >
          </el-form-item>
        </el-form>
        <el-table :data="gridData">
          <el-table-column
            align="center"
            width="50"
            type="selection"
            reserve-selection
          ></el-table-column>
          <el-table-column
            align="center"
            property="name"
            label="线路名称"
            width="200"
          ></el-table-column>
          <el-table-column
            align="center"
            property="address"
            label="线路编号"
          ></el-table-column>
        </el-table>
        <Pagination
          v-bind:child-msg="pageparm"
          @callFather="callFather"
        ></Pagination>
        <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
      </el-dialog>
      <!-- -------结束 -->
    </el-dialog>

    <!-- ----------- -->
  </div>
</template>

<script>
import dProgress from "../../components/Progress";
// import { AMapManager, lazyAMapApiLoaderInstance } from "vue-amap";
import battery from "../../components/battery";
import Pagination from "../../components/Pagination";
// const amapManager = new AMapManager(); // 新建生成地图画布
let conmap = "";
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  directives: {
    drag: {
      // 以下代码大家可以自己提出去封装一下
      inserted(el) {
        el.style.cursor = "move";
        var firstTime = "";
        var lastTime = "";
        el.onmousedown = function (e) {
          // 鼠标到文档的距离 - 鼠标到移动按钮的距离 = 按钮到文档的距离
          let disx = e.pageX - el.offsetLeft;
          let disy = e.pageY - el.offsetTop;
          document.getElementById("bd").setAttribute("data-flag", false);
          firstTime = new Date().getTime();
          document.onmousemove = function (e) {
            // 算移动后按钮到文档的距离，用按钮此刻距文档的距离-按钮原来到文档的距离，算出移动的距离
            let x = e.pageX - disx;
            let y = e.pageY - disy;
            // clientWidth = width + 左右padding
            // 获取按钮可移动最大距离
            let maxX =
              document.body.clientWidth -
              parseInt(window.getComputedStyle(el).width);
            let maxY =
              document.body.clientHeight -
              parseInt(window.getComputedStyle(el).height);

            el.style.left = x + "px";
            el.style.top = y + "px";

            // 按钮到文档的距离小于0，就让x=0，防止把按钮移出去
            if (x < 0) {
              向左;
              x = 0;
            } else if (x > maxX) {
              // 向右
              x = maxX;
            }

            if (y < 0) {
              y = 0;
            } else if (y > maxY) {
              y = maxY;
            }

            let et = e || window.event;
            et.preventDefault();
          };
          document.onmouseup = function () {
            lastTime = new Date().getTime();
            if (lastTime - firstTime < 150) {
              document.getElementById("bd").setAttribute("data-flag", true);
            }
            // 清楚鼠标事件
            document.onmousemove = document.onmouseup = null;
          };
        };
      },
    },
  },

  // ======================================
  name: "monitoring",
  components: {
    dProgress,
    battery,
    Pagination,
  },
  data() {
    return {
      showModal: false,
      routeShow: false,
      innerVisibleCar: false,
      car: "",
      map: "",
      route: "",
      // 搜索
      formInline: {
        name: "",
      },
      formInlines:{
        carId:"",
        carNumber:""
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      innerVisibleMap: false,
      innerVisibleRoute: false,
      runTime: "",
      // 新建任务验证
      ruleForm: {
        name: "",
        /*    clean: false,
          delivery: false,
          waterLevel: '', */
        ele: "",
        run_num: "",
        note: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入任务名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        /* waterLevel: [
            { required: true, message: '请输入水位阈值', trigger: 'blur' },
          ], */
        ele: [{ required: true, message: "请输入电量阈值", trigger: "blur" }],
        run_num: [
          { required: true, message: "请输入运行次数", trigger: "blur" },
        ],
        run_time: [
          { required: true, message: "请选择运行时间", trigger: "blur" },
        ],
      },
      // ---------------------------
      dialogFormTask: false,
      dialogTask: false,
      dialogEnd: false,
      // 车辆列表弹框
      gridData: [
        {
          name: "1005",
          address: "小赞小赞",
        },
        {
          name: "1005",
          address: "鲁A1005",
        },
        {
          name: "1005",
          address: "鲁A1005",
        },
        {
          name: "1005",
          address: "鲁A1005",
        },
      ],
      dialogTableCar: false,
      show_menu: "",
      batteryEnegy: 20,
      IsCharge: "",
      fu: true,
    };
  },
  mounted() {
    this.show();
  },
  computed: {},
  created() {
    this.test();
  },
  methods: {
    show() {
      AMapLoader.load({
        key: "872899e98d8b442ed41d45612fd91d4b", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: "", // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      }).then((AMap) => {
        // var center_path = result.locations;
        conmap = new AMap.Map("container", {
          //设置地图容器id
          viewMode: "3D", //是否为3D地图模式
          zoom: 15, //初始化地图级别
          center: [116.397428, 39.90923], //初始化地图中心点位置
          mapStyle: "amap://styles/blue", //设置地图的显示样式
        });
        var lnglat = [116.397428, 39.90923];
        AMap.convertFrom(lnglat, "gps", function (status, result) {
          if (result.info === "ok") {
            var resLnglat = result.locations[0];
            let m2 = new AMap.Marker({
              position: resLnglat,
            });
            conmap.add(m2);
            // 设置标签
            m2.setLabel({
              offset: new AMap.Pixel(20, 20),
            });
          }
        });
      });
    },

    // 选择车辆
    chooseCar() {
      this.innerVisibleCar = false;
    },
    // 选择地图
    chooseMap() {
      this.routeShow = true;
      this.innerVisibleMap = false;
    },
    // 选择线路
    chooseRoute() {
      this.innerVisibleRoute = false;
    },

    // 搜索
    onSubmit() {
      console.log("submit!");
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata(this.formInline);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    hmenu() {
      let isClick = document.getElementById("bd").getAttribute("data-flag");
      console.log(isClick);
      if (isClick !== "true") {
        // 大于150，就说明是移动，否则就是点击
        return false;
      }

      // 点击事件执行的代码
      console.log("888");
      this.show_menu = !this.show_menu;
    },

    goTo() {
      this.$router.push("/home");
      this.$store.commit("isShow");
    },

    test() {
      this.fu = !this.fu;
      this.$store.commit("isShow");
    },
  },

  // }
  // test() {
  //   this.$store.commit("isShow");
  // }
  // },
  // created() {
  //   this.test();
};
</script>
<style lang="css">
#container {
  width: 99.9%;
  height: 100%;
  position: absolute;
}

/* 移动按钮 */
.car_list {
  position: absolute;
  left: -52%;
  top: -5%;
}

.new_task {
  position: absolute;

  left: -52%;
  top: 85%;
}

.task_stop {
  width: 60%;
  /* border: #01cafb 1px solid; */
  position: absolute;
  left: 100%;
  top: -5%;
}

.task_end {
  width: 60%;
  position: absolute;
  left: 100%;
  top: 85%;
}

.menu_img1 {
  position: absolute;
  left: -62%;
  top: -30%;
  width: 100%;
  height: 80%;
}

.menu_img2 {
  position: absolute;
  left: -62%;
  top: 55%;
  width: 100%;
  height: 80%;
}

.menu_img3 {
  position: absolute;
  left: 62%;
  top: -30%;
  width: 100%;
  height: 80%;
}

.menu_img4 {
  position: absolute;
  left: 62%;
  top: 55%;
  width: 100%;
  height: 80%;
}

.menu {
  position: absolute;
  bottom: 5%;
  left: 4%;
  z-index: 999;
  width: 6%;
  height: 10%;

  color: #01cafb;

  margin-left: 0.3%;
}

.inmenu {
  margin: auto;
  width: 75%;
  height: 75%;
  text-align: center;
  line-height: 345%;
  border: rgb(17, 194, 238, 0.4) 10px solid;
  border-radius: 50%;
  font-size: 22px;
}

/* -------------------------------- */
/* 车辆列表弹框 */

/* ===================== */
.el-main {
  padding: 0 !important;
}

.el_progress {
  width: 100%;
}

.all {
  width: 100%;
  height: 100%;

  background-repeat: no-repeat;
}

.btn {
  position: absolute;
  top: 0.25%;
  left: 96%;
  z-index: 9999;
  color: #fff;
  background-color: aqua;
}

/* 标题 */
.title {
  width: 99.9%;
  height: 10%;
  display: flex;
  position: absolute;
  top: 0;
  justify-content: space-between;
  color: #01cafb;
  /* background: #01cafb; */
  z-index: 999;
}

.title_left {
  /* width: 25%; */
  width: 14%;
  /* margin-left: 2%; */
  /* padding-left: 5%; */
  /* border: red solid 1px; */
  background: url("../../assets/img/car/title_left.png") no-repeat;
  height: 50%;
}

.title_middle {
  width: 63%;
  background: url("../../assets/img/car/title.png") no-repeat;
  height: 100%;
  line-height: 200%;
  font-size: 28px;
  text-align: center;
  /* border: red solid 1px; */
}

.title_right {
  width: 14%;
  background: url("../../assets/img/car/title_right.png") no-repeat;
  height: 50%;
  /* border: red solid 1px; */
}

/* 左侧参数 */
.left_msg {
  width: 14%;
  font-size: 18px;
  /* background-image: url("../../assets/img/car/menu_h.png"); */
  /* background-color: red; */
  /* border: red solid 1px; */

  /* left: 10px; */
  margin: auto;
  z-index: 999;
  margin-left: 0.3%;
}

.msg1 {
  /* height: 15%; */
  position: absolute;
  top: 3%;
  height: 80px;
  background: url("../../assets/img/car/card1.png") no-repeat;
  background-size: 100% 80px;
}

.common {
  width: 100%;
  padding: 5px;
  display: flex;
  justify-content: space-between;
  color: aliceblue;
  display: flex;

  justify-content: space-between;

  /* background-color: red; */
}
.com_icon {
  width: 30px;
  height: 30px;
}
.ico {
  width: 100%;
  height: 100%;
}

.com_txt {
  width: 40%;
  font-size: 16px;
  color: #01cafb;
}

.com_msg {
  width: 40%;

  margin-top: 1.5%;

  font-size: 16px;
  color: #01cafb;
}

.msg2 {
  position: absolute;
  height: 80px;
  top: 14%;
  background: url("../../assets/img/car/card1.png") no-repeat;
  background-size: 100% 80px;
}

.msg3 {
  position: absolute;
  top: 25%;
  height: 160px;
  background: url("../../assets/img/car/card2.png") no-repeat;
  background-size: 100% 160px;
}

.msg4 {
  position: absolute;
  top: 44%;
  height: 60px;

  background: url("../../assets/img/car/card3.png") no-repeat;
  background-size: 100% 60px;
}

/* 剩余电量 水量 信号强度 */
.last_ele {
  padding-top: 5%;
  padding-left: 2%;
  width: 27%;
  color: #01cafb;
  height: 100%;
  font-size: 16px;
  /* z-index: 999; */
  /* border: red solid 1px; */
}

.last_line {
  width: 65%;
  padding-top: 5%;
  padding-left: 2%;
  display: flex;
  /* border: red solid 1px;
  background-color: seashell; */
}

.ele1 {
  width: 20%;
  height: 90%;
  background-color: rgba(0, 255, 255, 0.7);
  color: #fff;
}

.ele2 {
  width: 18%;
  height: 90%;
  background-color: rgba(0, 255, 255, 0.7);
  color: #fff;
  margin-left: 1.5%;
}

.ele3 {
  width: 18%;
  height: 90%;
  background-color: rgba(0, 255, 255, 0.7);
  color: #fff;
  margin-left: 1.5%;
}

.ele4 {
  width: 18%;
  height: 90%;
  background-color: rgba(0, 255, 255, 0.7);
  color: #fff;
  margin-left: 1.5%;
}

.ele5 {
  width: 18%;
  height: 90%;
  /* background-color: rgba(0, 255, 255, 0.7); */
  color: #fff;
  margin-left: 2.5%;
}

/* 剩余水量 */
.msg5 {
  position: absolute;
  top: 52%;
  height: 160px;
  background: url("../../assets/img/car/card2.png") no-repeat;
  background-size: 100% 160px;
}
.msg6 {
  position: absolute;
  bottom: 17%;
  height: 90px;
  padding: 10px;
  background: url("../../assets/img/car/card1.png") no-repeat;
  background-size: 93% 90px;
}

.water {
  position: absolute;
  top: 82%;
  left: 38%;
  color: #01cafb;
}

.water_txt {
  position: absolute;
  top: 38%;
  left: 45%;
}

/* 地图 */
._map {
  width: 99.9%;
  height: 100%;
  position: absolute;
}

/* 右侧数据 */
.right_msg {
  width: 14%;
  position: absolute;

  left: 85.8%;
  margin: auto;
  z-index: 999;
}

.rmsg_0 {
  position: absolute;
  top: 7%;
}

/* 天气 */
.weather {
  width: 100%;
  height: 20%;
}

/* 公共样式 */
.r_common {
  width: 100%;
  height: 32%;

  /* margin-top: 15%; */
  display: flex;
  justify-content: space-between;
}

.other_msg {
  /* height: 80%; */
}

.rico {
  width: 100%;
  height: 80%;
}

.rcom_icon {
  width: 13%;
  height: 80%;
  /* margin-top: 6%; */
  margin: 2% auto;
}

.rcom_txt {
  width: 45%;

  font-size: 18px;
  color: #01cafb;
  /* text-align: center; */
}

.rcom_msg {
  width: 30%;

  margin-top: 0.5%;
  /* background: #fff; */
  line-height: 240%;
  font-size: 18px;
  text-align: center;
  color: #01cafb;
}

/* 其他信息 */
.rmsg1 {
  position: absolute;
  top: 27%;
  /* border: gold solid 1px; */
  background: no-repeat url("../../assets/img/car/menu3.png");
}

.rmsg2 {
  position: absolute;
  top: 47%;
  /* border: gold solid 1px; */
  background: no-repeat url("../../assets/img/car/menu2.png");
}

.rmsg3 {
  position: absolute;
  top: 68%;
  background: no-repeat url("../../assets/img/car/menu1.png");
}

/* 位置 */
._position {
  width: 35%;
  height: 70%;
  /* background: #fff; */
  /* line-height: 235%; */
  padding-left: 5%;
  margin-top: 6%;
  font-size: 18px;
  color: #01cafb;
}

.rcom_msg_position {
  width: 55%;
  height: 72%;
  margin-top: 6.5%;
  padding-right: 2%;
  /* background: #fff; */
  line-height: 190%;
  /* margin-top: 2%; */
  font-size: 16px;
  /* text-align: center; */
  color: #01cafb;
}

.renwu {
  margin-top: 6%;
  height: 50%;
}

.common_video {
  width: 300px;
  height: 200px;

  /* border: gold solid 1px; */
  /* background-color: gold; */
  z-index: 999;
  background: no-repeat url("../../assets/img/car/caidan1.png");
  background-size: 100% 200px;
}

.video1 {
  position: absolute;
  top: 27%;
  right: 10px;
}

.video2 {
  position: absolute;
  right: 10px;
  bottom: 10px;
}
.video3 {
  position: absolute;
  right: 10px;
  bottom: 26%;
}

.in_video1 {
  width: 90%;
  height: 90%;
  margin: 3% auto;
  /* background-color: gold; */
  text-align: center;
  line-height: 500%;
  color: #01cafb;
  font-size: 28px;
}

.in_video2 {
  width: 90%;
  height: 90%;
  margin: 3% auto;
  /* background-color: gold; */
  text-align: center;
  line-height: 500%;
  color: #01cafb;
  font-size: 28px;
}

.chooseMap {
  margin-top: 1%;
  width: 99%;
  height: 30px;
  line-height: 30px;
  /* background-color: violet; */
  border: #dcdfe6 1px solid;
  border-radius: 3px;
}

.in_chooseMap {
  height: 30px;
  display: flex;
  justify-content: right;
  color: #888;
  margin-right: 2%;
}

/* 测试 */
/* .test {
  position: absolute;
  top: 260px;
  left: 86%;
  z-index: 999;
  width: 260px;
  height: 150px;
} */
.mask {
  background-color: #000;
  opacity: 0.3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.pop {
  background-image: url("../../assets/img/car/caidan1.png");
  background-size: 100% 100%;

  position: fixed;
  top: 150px;
  left: 500px;
  width: 900px;
  height: 700px;
  z-index: 99;
}
.glass {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #ffffff00;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 4px 12px;
}
</style>


// WEBPACK FOOTER //
// src/views/monitoring/Monitoring.vue